export default __webpack_public_path__ + "static/media/notAuthorized.6d8ffc85.svg";